import * as React from "react";

type IframeFormsProps = {
  iframesData: any;
  onIframesSend(): void
}

const IframeForms: React.FC<IframeFormsProps> = ({ iframesData, onIframesSend }) => {
  const [methodURLSent, setMethodURLSent] = React.useState(false);
  const [methodURLServerSent, setMethodURLServerSent] = React.useState(false);

  const methodURLFormRef = React.useRef<HTMLFormElement>(null);
  const methodURLServerFormRef = React.useRef<HTMLFormElement>(null);

  React.useEffect(() => {
    methodURLFormRef?.current?.submit();
    methodURLServerFormRef?.current?.submit();
  }, [iframesData]);

  React.useEffect(() => {
    if (methodURLFormRef.current && methodURLServerFormRef.current) {
      if (methodURLSent && methodURLServerSent) completeSent();
      return;
    }

    if (methodURLFormRef.current || methodURLServerFormRef.current) {
      (methodURLSent || methodURLServerSent) && completeSent();
    }
  }, [methodURLSent, methodURLServerSent]);

  const completeSent = () => {
    onIframesSend();
  };

  if (!iframesData) return null;

  return (
    <>
      <div>
        <div style={{ display: "none" }}>
          {iframesData.methodURL &&
            <iframe
              src=""
              name="methodURL"
              title="methodURL"
              onLoad={() => setMethodURLSent(true)}
            >
              <form
                ref={methodURLFormRef}
                action={iframesData.methodURL}
                target="methodURL"
                method="post"
              >
                <input type="hidden" name="threeDSMethodData" value={iframesData.methodDataPacked || ""} />
              </form>
            </iframe>
          }

          {iframesData.methodURLServer &&
            <iframe
              src=""
              name="methodURLServer"
              title="methodURLServer"
              onLoad={() => setMethodURLServerSent(true)}
            >
              <form
                ref={methodURLServerFormRef}
                action={iframesData.methodURLServer}
                target="methodURLServer"
                method="post"
              >
                <input type="hidden" name="threeDSServerTransId"
                       value={iframesData.serverTransID || ""} />
              </form>
            </iframe>
          }
        </div>
      </div>
    </>
  );
};

export default IframeForms;